import { render, staticRenderFns } from "./TaskChangeManager.vue?vue&type=template&id=d994dd4e&scoped=true&lang=pug&"
import script from "./TaskChangeManager.vue?vue&type=script&lang=js&"
export * from "./TaskChangeManager.vue?vue&type=script&lang=js&"
import style0 from "./TaskChangeManager.vue?vue&type=style&index=0&id=d994dd4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d994dd4e",
  null
  
)

export default component.exports